import './faro'; // Must be first — captures errors from all subsequent module evaluations
import { withFaroRouterInstrumentation } from '@grafana/faro-react';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import '@/utils/extendedYup/yupCustomMethods';
/* This comment prevents the linter from removing the import from the top of the file */
import App from '@/App';
import { DelayedLoading } from '@/components/Loading';
import { AccessTokenProvider } from '@/components/session/AccessTokenContext';
import { CollapseDrawerProvider } from '@/contexts/CollapseDrawerContext';
import { Auth0ProviderWithNavigate } from '@/provider/Auth0ProviderWithNavigate';
import { preloadIcons } from '@/utils/iconBundler';
import './tracing';

preloadIcons();

const container = document.getElementById('root');

//@ts-ignore
const root = createRoot(container);

const browserRouter = withFaroRouterInstrumentation(
  createBrowserRouter([
    {
      path: '*',
      element: (
        <Auth0ProviderWithNavigate>
          <AccessTokenProvider>
            <App />
          </AccessTokenProvider>
        </Auth0ProviderWithNavigate>
      ),
    },
  ]),
);

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <CollapseDrawerProvider>
        <RouterProvider router={browserRouter} fallbackElement={<DelayedLoading />}></RouterProvider>
      </CollapseDrawerProvider>
    </HelmetProvider>
  </React.StrictMode>,
);
